export const styles = {
  title: {
    margin: "30px 0px",
  },
};
